/* ==========================================================================
   DreamBrothers — db-cart-preview.js
   Swaps cart line-item thumbnails with the customer's personalized mockup,
   exactly like Gelato Personalization Studio does: the line item property
   `_productPreviewUrl` (written by db-configurator at add-to-cart) points to
   the rendered preview of the personalized design.

   Loaded by sections/db-configurator.liquid (product pages, drawer) and by
   sections/db-cart-preview.liquid (cart page). Theme-agnostic but tuned for
   Focal: images are `img.line-item__image` inside `a[href*="variant="]`.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__dbCartPreview) return;
  window.__dbCartPreview = true;

  var cache = { at: 0, items: null };

  function safeUrl(v) {
    v = String(v || '').trim();
    return /^(https?:)?\/\//i.test(v) ? v : '';
  }

  function fetchCart() {
    var now = Date.now();
    if (cache.items && now - cache.at < 1500) return Promise.resolve(cache.items);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (c) {
        cache = { at: Date.now(), items: c.items || [] };
        return cache.items;
      })
      .catch(function () { return cache.items || []; });
  }

  function variantFromRow(img) {
    var a = img.closest('a[href]');
    if (!a) return null;
    var m = String(a.getAttribute('href') || '').match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function setImg(img, url) {
    if (img.getAttribute('data-db-preview') === url) return;
    img.setAttribute('data-db-preview', url);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
    img.style.objectFit = 'contain';
    img.style.background = '#ffffff';
  }

  function apply() {
    fetchCart().then(function (items) {
      var any = items.some(function (it) {
        return it.properties && safeUrl(it.properties._productPreviewUrl);
      });
      if (!any) return;

      // Cart lines per variant, in cart order.
      var linesByVariant = {};
      items.forEach(function (it) {
        var vid = String(it.variant_id);
        (linesByVariant[vid] = linesByVariant[vid] || []).push(it);
      });

      // DOM rows per variant, in DOM order. The drawer and the cart page can
      // both be present: rows repeat, so lines are assigned cyclically.
      var rowsByVariant = {};
      document.querySelectorAll('img.line-item__image').forEach(function (img) {
        var vid = variantFromRow(img);
        if (!vid) return;
        (rowsByVariant[vid] = rowsByVariant[vid] || []).push(img);
      });

      Object.keys(rowsByVariant).forEach(function (vid) {
        var lines = linesByVariant[vid] || [];
        if (!lines.length) return;
        rowsByVariant[vid].forEach(function (img, i) {
          var line = lines[i % lines.length];
          var url = line && line.properties && safeUrl(line.properties._productPreviewUrl);
          if (url) setImg(img, url);
        });
      });
    });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // Cart drawer re-renders its line items after every cart change.
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('img.line-item__image')) ||
              (n.querySelector && n.querySelector('img.line-item__image'))) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { /* ignore */ }

  // Focal / theme event buses (best effort).
  ['cart:updated', 'cart:refresh', 'cart:change', 'variant:added'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });
})();
